import { Component } from '@angular/core';

@Component({
  selector: 'csl-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent {

}
